import { ATTR_TYPE_DATE, ATTR_TYPE_TEXT_COLLECTION } from 'pages/RolesAndPermissions/consts';

function comparisonToDisplayName(comparison: string, fieldType: string) {
  switch (comparison) {
    case 'eq':
      return fieldType === ATTR_TYPE_TEXT_COLLECTION ? 'includes' : 'is';
    case 'neq':
      return fieldType === ATTR_TYPE_TEXT_COLLECTION ? 'does not include' : 'is not';
    case 'ct':
      return 'contains';
    case 'nct':
      return 'does not contain';
    case 'hav':
      return fieldType === ATTR_TYPE_TEXT_COLLECTION ? 'is not empty' : 'has any value';
    case 'ukn':
      return fieldType === ATTR_TYPE_TEXT_COLLECTION ? 'is empty' : 'has no value';
    case 'lt':
      return fieldType === ATTR_TYPE_DATE ? 'is before' : 'is less than';
    case 'gt':
      return fieldType === ATTR_TYPE_DATE ? 'is after' : 'is greater than';
  }

  return comparison;
}

export default comparisonToDisplayName;
